import { HttpErrorResponse } from '@angular/common/http';

import { createAction, props } from '@ngrx/store';

import { Module } from 'src/app/models/module';

export const getModulesSuccess = createAction('[Modules] Get Modules Success', props<{ modules: Module[] }>());

export const getModulesError = createAction('[Modules] Get Modules Error', props<{ err: HttpErrorResponse }>());

export const getModulesInSelectedIntervention = createAction(
  '[Modules] Get Modules In Selected Intervention',
  props<{ studyId: number; interventionId: number }>()
);

export const getModulesInSelectedInterventionSuccess = createAction(
  '[Modules] Get Modules In Selected Intervention Success',
  props<{ modules: Module[] }>()
);

export const getModulesInSelectedInterventionError = createAction(
  '[Modules] Get Modules In Selected Intervention Error',
  props<{ err: HttpErrorResponse }>()
);

export const getModule = createAction('[Modules] Get Module ', props<{ studyId: number; moduleId: number }>());

export const getModuleSuccess = createAction('[Modules] Get Module Success', props<{ selectedModule: Module }>());

export const getModuleError = createAction('[Modules] Get Module Error', props<{ err: HttpErrorResponse }>());

export const selectModule = createAction('[Modules] Select Module', props<{ moduleId: number }>());

export const setSelectedModule = createAction('[Module] Set Selected Module', props<{ selectedModule: Module }>());

export const createModule = createAction('[Module] Create Module', props<{ module: Module }>());

export const createModuleSuccess = createAction('[Module] Create Module Success', props<{ newModule: Module }>());

export const createModuleError = createAction('[Module] Create Module Error', props<{ err: HttpErrorResponse }>());

export const updateModule = createAction('[Module] Update Module', props<{ module: Module }>());

export const updateModuleSuccess = createAction('[Module] Update Module Success', props<{ updatedModule: Module }>());

export const updateModuleError = createAction('[Module] Update Module Error', props<{ err: HttpErrorResponse }>());

export const duplicateModule = createAction('[Module] Duplicate Module', props<{ module: Module }>());

export const duplicateModuleSuccess = createAction(
  '[Module] Duplicate Module Success',
  props<{ duplicatedModule: Module }>()
);

export const duplicateModuleError = createAction(
  '[Module] Duplicate Module Error',
  props<{ err: HttpErrorResponse }>()
);

export const deleteModule = createAction('[Module] Delete Module', props<{ module: Module }>());

export const deleteModuleSuccess = createAction('[Module] Delete Module Success', props<{ deletedModule: Module }>());

export const deleteModuleError = createAction('[Module] Delete Module Error', props<{ err: HttpErrorResponse }>());

export const exportModuleToCSV = createAction('[Module] Export Module To CSV', props<{ module: Module }>());
